"use strict";

require("../../docs.css");
require("@ebay/skin/tokens");
require("@ebay/skin/global");
require("@ebay/skin/utility");
require("@ebay/skin/button");
require("@ebay/skin/icon-button");
require("@ebay/skin/link");
require("@ebay/skin/textbox");
require("@ebay/skin/alert-dialog");
require("@ebay/skin/confirm-dialog");
require("@ebay/skin/drawer-dialog");
require("@ebay/skin/fullscreen-dialog");
require("@ebay/skin/lightbox-dialog");
require("@ebay/skin/panel-dialog");
require("@ebay/skin/snackbar-dialog");
require("@ebay/skin/toast-dialog");
var _makeupDialogButton = _interopRequireDefault(require("makeup-dialog-button"));
var _makeupLightboxDialog = _interopRequireDefault(require("makeup-lightbox-dialog"));
var _makeupAlertDialog = _interopRequireDefault(require("makeup-alert-dialog"));
var _makeupConfirmDialog = _interopRequireDefault(require("makeup-confirm-dialog"));
var _makeupDrawerDialog = _interopRequireDefault(require("makeup-drawer-dialog"));
var _makeupFullscreenDialog = _interopRequireDefault(require("makeup-fullscreen-dialog"));
var _makeupInputDialog = _interopRequireDefault(require("makeup-input-dialog"));
var _makeupPanelDialog = _interopRequireDefault(require("makeup-panel-dialog"));
var _makeupSnackbarDialog = _interopRequireDefault(require("makeup-snackbar-dialog"));
var _makeupToastDialog = _interopRequireDefault(require("makeup-toast-dialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// STYLES

// REQUIRE
/*
const DialogButton = require('makeup-dialog-button');
const LightboxDialog = require('makeup-lightbox-dialog');
const AlertDialog = require('makeup-alert-dialog');
const ConfirmDialog = require('makeup-confirm-dialog');
const DrawerDialog = require('makeup-drawer-dialog');
const FullscreenDialog = require('makeup-fullscreen-dialog');
const InputDialog = require('makeup-input-dialog');
const PanelDialog = require('makeup-panel-dialog');
const SnackbarDialog = require('makeup-snackbar-dialog');
const ToastDialog = require('makeup-toast-dialog');
*/

// IMPORT

const log = e => console.log(e); // eslint-disable-line no-console

window.onload = function () {
  document.querySelectorAll(".dialog-button").forEach(function (el, i) {
    const dialogId = el.dataset.makeupFor;
    const dialogEl = document.getElementById(dialogId);
    const dialogClassList = dialogEl.classList;
    let dialogWidget;
    if (dialogClassList.contains("confirm-dialog")) {
      dialogWidget = new _makeupConfirmDialog.default(dialogEl);
    } else if (dialogClassList.contains("alert-dialog")) {
      dialogWidget = new _makeupAlertDialog.default(dialogEl);
    } else if (dialogClassList.contains("lightbox-dialog--input")) {
      dialogWidget = new _makeupInputDialog.default(dialogEl);
    } else if (dialogClassList.contains("fullscreen-dialog")) {
      dialogWidget = new _makeupFullscreenDialog.default(dialogEl);
    } else if (dialogClassList.contains("snackbar-dialog")) {
      dialogWidget = new _makeupSnackbarDialog.default(dialogEl);
    } else if (dialogClassList.contains("toast-dialog")) {
      dialogWidget = new _makeupToastDialog.default(dialogEl);
    } else if (dialogClassList.contains("drawer-dialog")) {
      dialogWidget = new _makeupDrawerDialog.default(dialogEl);
    } else if (dialogClassList.contains("panel-dialog")) {
      dialogWidget = new _makeupPanelDialog.default(dialogEl);
    } else if (dialogClassList.contains("lightbox-dialog")) {
      dialogWidget = new _makeupLightboxDialog.default(dialogEl);
    }
    const buttonWidget = new _makeupDialogButton.default(el, dialogWidget);
    dialogWidget._el.addEventListener("dialog-open", log);
    dialogWidget._el.addEventListener("dialog-close", log);
  });
};